import { descriptors } from "../packages/descriptors.js";
import { validation } from "../packages/validation.js";

class EntityEnvironment {
  constructor(name) {
    this.name = name;
    this.handlers = {};
  }

  extendParentHandlers(childHandlers) {
    return {
      ...this.handlers,
      ...childHandlers,
    };
  }

  update(node, config) {
    const { key, value } = config;

    if (typeof this[key] === "function") {
      this[key](node, value);
      return;
    }

    const entry = this.handlers[key];

    if (!entry) {
      node.props[key] = value;
      const derivedName = key.replace(/\.(\w)/g, (_, c) => c.toUpperCase());
      if (typeof this[derivedName] === "function") {
        this[derivedName](node);
      }
      return;
    }

    const descriptor = descriptors.get(node.namespace);
    const propDef = descriptor?.properties[key];

    if (propDef && !(typeof value === 'string' && propDef.type !== 'string' && propDef.type !== 'expression')) {
      const result = validation.validateProperty(value, propDef);
      if (!result.isValid) return;
    }

    node.props[key] = value;

    const handler = typeof entry === "function" ? entry : entry.handler;
    handler.call(this, node);
  }

  create(node) {}

  destroy(node) {}
}

export { EntityEnvironment };
